/**
 * React hook for tracking PostHog events
 */

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { trackEvent as trackEventAction, PosthogEventProperties } from '~/services/posthog';
import { validateEventProperties } from '~/utils/posthog/validators';
import { sanitizePayload } from '~/utils/posthog/sanitizers';

/**
 * Hook for tracking events through Redux
 */
export const useTrackEvent = () => {
  const dispatch = useDispatch();

  const trackEvent = useCallback(
    (eventName: string, properties?: PosthogEventProperties) => {
      // Sanitize and validate properties
      const sanitized = properties ? sanitizePayload(properties) : undefined;
      const validated = validateEventProperties(sanitized);

      // Dispatch the action
      dispatch(trackEventAction(eventName, validated));
    },
    [dispatch]
  );

  return trackEvent;
};